import { render, staticRenderFns } from "./ConcernedInfoPage.vue?vue&type=template&id=bd0fd8b4&scoped=true&"
import script from "./ConcernedInfoPage.vue?vue&type=script&lang=js&"
export * from "./ConcernedInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0fd8b4",
  null
  
)

export default component.exports